<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
    layout: WebLayout,
}
</script>

<script setup>
import LegalDocument from '@/components/LegalDocument.vue'
</script>

<template>
    <LegalDocument translation-key="subprocessors" route-name="web.subprocessors" />
</template>
